import { render } from "./UserManagementInfo.vue?vue&type=template&id=d641f384&scoped=true"
import script from "./UserManagementInfo.vue?vue&type=script&lang=js"
export * from "./UserManagementInfo.vue?vue&type=script&lang=js"

import "./UserManagementInfo.vue?vue&type=style&index=0&id=d641f384&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d641f384"]])

export default __exports__